import React from "react";
import { css } from "react-emotion";
import { withRedux } from "helpers";
import { flex } from "appStyles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const profileContainer = css`
  max-height: 4rem;
  cursor: pointer;
`;

const profileStyle = css`
  display: flex;
  align-content: flex-end;
  justify-content: space-around;
  align-items: center;
  /* width: 9rem; */
  margin-right: 15px;
  height: 3em;
  font-size: 1.2rem;
  color: #5f6368;
  cursor: pointer;
  * {
    cursor: pointer;
  }
  @media only screen and (max-width: 500px) {
    margin-right: 1em;
  }
`;

const dropdown = css`
  position: fixed;
  z-index: 2;
  right: 0;
  top: 4.05em;
  background: white;
  cursor: pointer;
  background: #fff;
  border: 1px solid #ccc;
  border-color: rgba(0, 0, 0, 0.2);
  color: #000;
  -webkit-box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
  box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
`;

const option = css`
  ${flex};
  font-size: 0.9375rem;
  width: 7rem;
  height: 2.5rem;

  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  -webkit-transition-property: color;
  transition-property: color;
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;

  ::before {
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgb(137, 210, 211);
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transform-origin: 0 50%;
    transform-origin: 0 50%;
    -webkit-transition-property: transform;
    transition-property: transform;
    -webkit-transition-duration: 0.5s;
    transition-duration: 0.5s;
    -webkit-transition-timing-function: ease-out;
    transition-timing-function: ease-out;
  }
  &:hover,
  &:focus,
  &:active {
    color: white;
  }
  &:hover:before,
  &:focus:before,
  &:active:before {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
    -webkit-transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
    transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
  }
`;

class Profile extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    showDropdown: false,
  };

  toggleDropdown = (e) => {
    e.stopPropagation();
    this.setState((prevState) => ({ showDropdown: !prevState.showDropdown }));
  };

  logOut = () => {
    this.props.actions.resetDisplay();
    this.props.actions.resetApplications();
    this.props.actions.logOut();
  };

  render() {
    let {
      platformInfo: {
        status: { user },
      },
    } = this.props;

    if (!user) return <div />;

    return (
      <div
        className={profileContainer}
        onClick={this.toggleDropdown}
        ref={(node) => (this.node = node)}
      >
        <div className={profileStyle}>
          <FontAwesomeIcon icon="user" />
        </div>

        {this.state.showDropdown && (
          <div className={dropdown}>
            <div className={option} onClick={this.logOut}>
              Log Out
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRedux(Profile);
